import angular from 'angular';
import '../../shared.module';
import template from './toast.component.html';
import './toast.component.scss';

const ICONS_BY_TYPE = {
  success: 'check-circle',
  error: 'alert-circle',
  warning: 'alert-circle',
  info: 'info'
};

class ToastController {
  constructor(NotificationService, $rootScope) {
    this.NotificationService = NotificationService;
    this.$rootScope = $rootScope;
    this.notifications = [];
  }

  $onInit() {
    this.subscription = this.NotificationService.notifications$.subscribe((notifications) => {
      this.notifications = notifications;
      this.$rootScope.$applyAsync();
      notifications.forEach((notification) => this.scheduleAutoDismiss(notification));
    });
  }

  scheduleAutoDismiss(notification) {
    if (notification.scheduled) return;
    notification.scheduled = true;
    setTimeout(() => this.dismiss(notification.id), notification.timeout);
  }

  iconFor(type) {
    return ICONS_BY_TYPE[type] || 'info';
  }

  dismiss(id) {
    this.NotificationService.dismiss(id);
  }

  $onDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}

ToastController.$inject = ['NotificationService', '$rootScope'];

angular.module('app.shared').component('cpToastContainer', {
  controller: ToastController,
  controllerAs: 'vm',
  template
});
